import {CoinbaseWallet} from '@web3-react/coinbase-wallet';
import {
  useConnectEagerly,
  useConnector,
  useInitializeConnector,
  useSwitchChain,
} from '../hooks';
import {Web3ConnectionType} from '../types';
import {useCallback, useEffect} from 'react';
import {BaseConnectorProps} from './types';

export const Coinbase = ({
  options,
  onStateUpdate,
  onConnectorUpdate,
  chainId,
}: BaseConnectorProps<CoinbaseWallet>) => {
  const connector = useInitializeConnector(
    Web3ConnectionType.COINBASE,
    useCallback(
      actions => {
        return new CoinbaseWallet({
          actions,
          options: {
            ...options.coinbase,
            url: options.urls[options.defaultChainId][0],
          },
        });
      },
      [options.defaultChainId, options.urls]
    )
  );

  useEffect(() => {
    onConnectorUpdate(connector.connector);
  }, [connector.connector, onConnectorUpdate]);

  const state = useConnector(connector, onStateUpdate);

  useConnectEagerly(connector.connector, Web3ConnectionType.COINBASE);

  useSwitchChain(connector.connector, state, chainId || options.defaultChainId);

  return null;
};
